import styled from "@emotion/styled";
import {
  Autocomplete,
  Chip,
  FormControl,
  FormHelperText,
  InputLabel,
  TextField,
} from "@mui/material";
import React from "react";
import CloseIcon from "@mui/icons-material/Close";

const Select = styled(Autocomplete)(({ theme }) => ({
  marginTop: 24,
  borderRadius: "12px",
  "& .MuiOutlinedInput-root": {
    backgroundColor: "#FFF",
    padding: "12px", // Added padding
    borderRadius: "12px", // Added border-radius
    "&.Mui-focused, &:focus-within": {
      boxShadow: "none", // Remove box shadow on focus
      borderColor: "transparent", // Ensure no border change
      border: "none",
    },
    "& .MuiInputBase-root, & .MuiOutlinedInput-root": {
      boxShadow: "none", // Remove box shadow for these classes
    },
    "& .MuiAutocomplete-input": {
      borderRadius: "12px",
      position: "relative",
      backgroundColor: "#FFF",
      fontSize: 14,
      fontFamily: "Inter Tight",
      padding: 0,
    },
    "& .MuiAutocomplete-tag": {
      padding: 0,
      margin: 0,
    },
    "& .MuiInputBase-root.MuiOutlinedInput-root.Mui-focused": {
      borderColor: "transparent", // Remove border color on focus
      boxShadow: "none", // Remove box shadow on focus
    },
  },
  "& .css-tlowbv-MuiAutocomplete-root": {
    backgroundColor: "#FFF", // Set background color
  },
}));

export default function Cselect(props) {
  const {
    handleSelect = () => null,
    label = "",
    required = false,
    error = false,
    helpertext = "",
    multiple = false,
    placeholder = "",
    renderTags = [],
    value = [],
  } = props;

  const val = multiple ? value || [] : value || null;
  return (
    <FormControl variant="standard" fullWidth required={required} error={error}>
      {label && (
        <InputLabel shrink htmlFor="bootstrap-input">
          {label}
        </InputLabel>
      )}
      <Select
        style={{
          border: error ? "1px solid red" : "none",
        }}
        variant="contained"
        id="tags-outlined"
        multiple={multiple}
        options={
          multiple ? renderTags.map((item) => item.project_name) : renderTags
        }
        filterSelectedOptions={multiple ? true : false}
        renderInput={(params) => (
          <TextField {...params} placeholder={placeholder} />
        )}
        value={val}
        onChange={(a, b, c, e) => {
          handleSelect(b);
        }}
        renderTags={(value, getTagProps) =>
          value.map((option, index) => (
            <Chip
              {...props}
              variant="outlined"
              label={option}
              deleteIcon={<CloseIcon />}
              {...getTagProps({ index })}
              sx={{
                fontWeight: "normal",
                textTransform: "uppercase",
                pl: "16px",
                bgcolor: "rgba(245, 246, 248, 1)",
                border: "none",
                "& .MuiChip-deleteIcon": {
                  position: "absolute",
                  left: 10,
                  bgcolor: "transparent",
                  color: "rgba(0, 0, 0, 1)",
                },
              }}
            />
          ))
        }
      />
      {helpertext && (
        <FormHelperText
          error={error}
          style={{ marginBottom: 20, fontFamily: "Inter Tight" }}
        >
          {helpertext}
        </FormHelperText>
      )}
    </FormControl>
  );
}
